export default __webpack_public_path__ + "img/logo.ef8ab609.png";